import assessmentService from "../services/assessment.service";
import ACTION_TYPE from "./type.action";

export const createAssessment = (classid, name, username) => async dispatch => {
  await assessmentService.create(classid, name, username);
  let assessments = await assessmentService.fetch(classid);
  dispatch({
    type: ACTION_TYPE.CREATE_ASSESSMENT,
    payload: assessments
  });
};

export const fetchAssessment = classid => async dispatch => {
  let assessments = await assessmentService.fetch(classid);
  dispatch({
    type: ACTION_TYPE.FETCH_ASSESSMENTS,
    payload: assessments
  });
};

export const readAssessment = classid => async dispatch => {
  let assessmentdata = await assessmentService.read(classid);
  dispatch({
    type: ACTION_TYPE.READ_ASSESSMENT,
    payload: assessmentdata
  });
};

export const filterAssessment = assessments => async dispatch => {
  dispatch({
    type: ACTION_TYPE.FILTER_ASSESSMENT,
    payload: assessments
  });
};

export const readQuestions = classid => async dispatch => {
  let assessmentdata = await assessmentService.read(classid);
  dispatch({
    type: ACTION_TYPE.READ_QUESTIONS,
    payload: assessmentdata
  });
};

export const setIsWebView = (status) => async dispatch => {
  if(status == undefined){
    status = false
  }
  dispatch({
    type: ACTION_TYPE.IS_WEB_VIEW,
    payload: status
  });
};

export const setIsKtvAssessment = (status) => async dispatch => {
  if(status == undefined){
    status = false
  }
  dispatch({
    type: ACTION_TYPE.IS_KTV_ASSESSMENT_VIEW,
    payload: status
  });
};